/**
 * 处理逗号分割的查询字段, 逗号、空格、换行符分隔的字符串转数组
 * 支持通过excel复制数据－粘贴到文本框，系统自动拼接逗号隔开，进行查询
 * @param {string} value 查询字段的值
 * @returns {string[]}
 */
export function searchFieldSeperated(value) {
    return (value || '')
        .replace('，', ',')
        .replace(/\s+/g, ',')
        .split(/[,，]/)
        .map(no => no.trim())
        .filter(no => no);
}
